import { WorkContext } from 'utils/getContext'
import { useNavigate } from 'react-router-dom'
import canHandle from 'static/images/canHandle.png'
import jump from 'static/images/jump.png'
import { TRUE_FLAG_NUM } from 'utils/constant'

const SatisfyItem = () => {
  const navigate = useNavigate()
  // 点击跳转到对应的页面
  const handleClick = (item) => {
    const {url, openType: type } = item
    if (type === TRUE_FLAG_NUM) {
      navigate(url)
    } else {
      window.open(url)
    }
  }
  return (
    <WorkContext.Consumer>
      {value => {
        const { satisfyList } = value
        // 如果没有满足条件的事项，就不展示
        if (!satisfyList || satisfyList.length === 0) return null
        return (
          <div className="recommend-item">
            <div className="recommend-item-title">根据比对结果，推荐您办理以下事项</div>
            <div className="list">
              {satisfyList.map(item => {
                const { id, name } = item
                return (
                  <div className="item" key={id} onClick={() => handleClick(item)}>
                    <div className="item-title">
                      <img src={canHandle} alt="可办理" />
                      {name}
                    </div>
                    <div className="item-content">
                      <span className='link'>去申请</span>
                      <img src={jump} alt="跳转" />
                    </div>
                  </div>
                )
              })
              }
            </div>
          </div>
        )
      }
      }
    </WorkContext.Consumer>
  )
}

export { SatisfyItem }